import { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';

//
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';

//
import Body from '../components/Body/Body';
import Header from '../components/Header/Header';
import { FormattedMessage } from 'react-intl';

//
import '../index.scss';
import { useParams } from 'react-router-dom';
import { ErrorMessageHandler } from '../../../../../_helpers/_methods';
import { toast } from 'react-toastify';

/**
 *
 */
export default function Certificate({ preview }) {
  const { id } = useParams();
  const certificateRef = useRef();
  const certificate = useSelector((state) => state.certificate);

  const handlePrint = useReactToPrint({
    content: () => {
      return certificateRef.current;
    }
  });

  const CertificateCanvasStyle = {
    padding: '30px 60px'
  };

  const handleCertificateTemplateSave = async () => {
    try {
      await fetchWrapper.post('/certificate/template/', {
        event: id,
        template: certificate
      });
      toast.success(<FormattedMessage id="certificate-success" />);
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  return (
    <div className="certificate">
      {!preview && (
        <>
          <h2 className="my-3 text-center">
            <b>Event Certificate Builder</b>
          </h2>

          <div className="alert alert-info">
            NOTE: <FormattedMessage id="certificate-builder-instruction" />
          </div>
        </>
      )}

      <div
        style={CertificateCanvasStyle}
        ref={certificateRef}
        className="certificate-paper border rounded">
        <Header preview={preview} />
        <Body preview={preview} />
      </div>

      <div className="text-center mt-2">
        <Button
          className="me-2"
          variant={preview ? 'primary' : 'outline-primary'}
          onClick={handlePrint}>
          {preview ? 'Print' : 'Preview'}
        </Button>
        {!preview && <Button onClick={handleCertificateTemplateSave}>Save</Button>}
      </div>
    </div>
  );
}
